/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_ErrorInputs */

const en_reports_export_error = /** @type {(inputs: Reports_Export_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not generate the report.`)
};

const pt_br2_reports_export_error = /** @type {(inputs: Reports_Export_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível gerar o relatório.`)
};

/**
* | output |
* | --- |
* | "Could not generate the report." |
*
* @param {Reports_Export_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_error = /** @type {((inputs?: Reports_Export_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_error(inputs)
	return pt_br2_reports_export_error(inputs)
});